var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"my-4"},[_vm._v("\n    Moderator: "),_c('strong',[_vm._v(_vm._s(_vm.moderator.name))]),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-danger ml-3"},[_vm._v("GELÖSCHT")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex mb-4"},[_c('moderator-update',{attrs:{"moderator":_vm.moderator}}),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"card ml-5 flex-grow-1"},[_c('div',{staticClass:"card-body"},[_c('v-button',{attrs:{"working":_vm.working},nativeOn:{"click":function($event){return _vm.toggleAgencyLeader()}}},[(_vm.agencyLeader)?_c('span',[_vm._v(" Agenturleitung entziehen")]):_c('span',[_vm._v(" Agenturleitung erteilen")])])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"d-flex mb-4"},[_c('v-table',{staticClass:"flex-grow-1",attrs:{"url":"/api/v1/message","filter":[
        {
          name: 'with',
          value: ['sender', 'receiver']
        },
        {
          name: 'where',
          attributes: {
            moderator_profile_id: _vm.moderator.moderator_profile.id
          }
        }
      ],"attributes":[
        {
          name: 'Dialog',
          attribute: 'dialogMessageId',
          type: 'ClickableIdCell',
          sortable: false
        },
        {
          attribute: 'sender',
          name: 'Von',
          type: 'ProfileCell'
        },
        {
          attribute: 'receiver',
          name: 'An',
          type: 'ProfileCell'
        },
        {
          attribute: 'dEType',
          name: 'Nachrichtentyp',
          sortable: false
        },
        {
          attribute: 'body',
          name: 'Nachricht'
        },
        {
          attribute: 'created_at',
          name: 'Datum',
          type: 'DateTimeCell'
        }
      ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        Nachrichten\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 bg-white p-0 mb-4"},[_c('div',{staticClass:"flex-row"},[_c('v-table',{staticClass:"flex-grow-1",attrs:{"url":_vm.historyUrl,"attributes":[
          {
            name: 'Heute',
            attribute: 'today'
          },
          {
            attribute: 'this week',
            name: 'Diese Woche'
          },
          {
            attribute: 'last week',
            name: 'Letzte Woche'
          },
          {
            attribute: 'this month',
            name: 'Dieser Monat'
          },
          {
            attribute: 'last month',
            name: 'letzter Monat'
          },
          {
            attribute: 'all',
            name: 'Total'
          }
        ]}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Statistik INs / Outs [Transactions] ")])])],1),_vm._v(" "),_c('div',{staticClass:"flex-row"},[_c('v-table',{ref:"table-transactions",attrs:{"url":"/api/v1/moderator-transaction/","filter":_vm.earningsFilter,"attributes":[
          {
            attribute: 'price',
            name: 'Einheiten'
          },
          {
            attribute: 'created_at',
            name: 'Am',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('table-filter',{attrs:{"filterComponents":[
              {
                type: 'DateRangeFilter',
                label: 'Zeitraum'
              }
            ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table', _vm.$refs['table-transactions'].id)}},model:{value:(_vm.earningsFilter),callback:function ($$v) {_vm.earningsFilter=$$v},expression:"earningsFilter"}})],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('v-table',{ref:"table-work-sessions",attrs:{"url":"/api/v1/moderatorWorkSession","filter":_vm.workSessionFilter,"attributes":[
        {
          attribute: 'created_at',
          name: 'Von',
          type: 'DateTimeCell'
        },
        {
          attribute: 'completed_at',
          name: 'Bis',
          type: 'DateTimeCell'
        },
        {
          attribute: 'duration',
          name: 'Zeitraum'
        }
      ]}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Arbeitszeiten")]),_vm._v(" "),_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('table-filter',{attrs:{"filterComponents":[
            {
              type: 'DateRangeFilter',
              label: 'Zeitraum'
            }
          ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table', _vm.$refs['table-work-sessions'].id)}},model:{value:(_vm.workSessionFilter),callback:function ($$v) {_vm.workSessionFilter=$$v},expression:"workSessionFilter"}})],1)])],1),_vm._v(" "),(_vm.isAdmin)?_c('admin-support-message-resource',{attrs:{"moderatorId":_vm.moderator.id}}):_vm._e(),_vm._v(" "),(!_vm.isDeleted && _vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/userSession","filter":[
          {
            name: 'where',
            attributes: {
              user_id: this.id
            }
          }
        ],"attributes":[
          {
            attribute: 'ip',
            name: 'IP-Adresse'
          },
          {
            attribute: 'country_code',
            name: 'Land',
            type: 'FlagCell'
          },
          {
            attribute: 'session_id',
            name: 'Session-ID'
          },
          {
            attribute: 'user_agent',
            name: 'Browser- und Gerätedaten'
          },
          {
            attribute: 'created_at',
            name: 'Erstellt am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'closed_at',
            name: 'Geschlossen am',
            type: 'DateTimeCell'
          },
          {
            attribute: 'duration',
            name: 'Zeitspanne'
          },
          {
            attribute: 'success',
            name: 'Erfolgreich eingeloggt',
            type: 'CheckMarkerCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Anmeldungen")])])],1)]):_vm._e(),_vm._v(" "),(!_vm.isDeleted && _vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v2-table',{attrs:{"url":`/api/v1/ping?filter[moderator_profile_id]=${this.moderator.moderator_profile.id}&paginate`,"headers":[
          {
            text: 'Start'
          },
          {
            text: 'Ende'
          },
          {
            text: 'Durchschnitt'
          }
        ]},scopedSlots:_vm._u([{key:"row",fn:function({ item }){return _c('tr',{},[_c('date-time-cell',{attrs:{"content":item.started_at}}),_vm._v(" "),_c('date-time-cell',{attrs:{"content":item.ended_at}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.average)+" ms")])],1)}}],null,false,1849307008)})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }